/* Copyright (c) 2017 Backpack Health LLC */

import { apiRequest, authorizedApiRequest } from './ApiRequest';

import ApiErrorModel from '../models/ApiErrorModel';

const GroupApi = {
  getMetadata: function getGroupMetadata(subdomain) {
    return apiRequest('get', `groups/metadata?subdomain=${subdomain}`);
  },
  search: function searchGroup(searchParams) {
    const params = searchParams ? `?q=${searchParams}` : '';
    return authorizedApiRequest('get', `groups/search${params}`);
  },
  groupsForProfile: function groupsForProfile(profileId) {
    return authorizedApiRequest('get', `profiles/${profileId}/groups`);
  },
  join: function joinGroup(profileId) {
    return authorizedApiRequest('post', `profiles/${profileId}/groups`);
  },
  leave: function leaveGroup(profileId, groupId) {
    return authorizedApiRequest('delete', `profiles/${profileId}/groups/${groupId}`);
  },
  getGroupContents: async function getGroupContents(profileId, category) {
    try {
      const categoryParam = category ? `?category=${category}` : '';
      const { body: { data } } = await authorizedApiRequest('get', `profiles/${profileId}/groups/content${categoryParam}`);
      return data;
    } catch (e) {
      throw new ApiErrorModel(e);
    }
  },
};

const GroupService = {

  getMetadata(subdomain, callback) {
    return GroupApi.getMetadata(subdomain)
      .end((err, res) => {
        const apiError = err ? new ApiErrorModel(err) : null;
        callback(apiError, res.body.data);
      });
  },

  getMetadataById: (id, callback) => {
    return apiRequest('get', `groups/metadata?id=${id}`)
      .end((err, res) => {
        const apiError = err ? new ApiErrorModel(err) : null;
        callback(apiError, res.body.data);
      });
  },

  search(searchParams, callback) {
    return GroupApi.search(searchParams)
      .end((err, res) => {
        const apiError = err ? new ApiErrorModel(err) : null;
        callback(apiError, res.body.data);
      });
  },

  getGroupsForProfile(profileId, callback) {
    return GroupApi.groupsForProfile(profileId)
      .end((err, res) => {
        const apiError = err ? new ApiErrorModel(err) : null;
        callback(apiError, res.body.data);
      });
  },

  joinGroup(profileId, groupMetadata, callback) {
    return GroupApi.join(profileId)
      .send(groupMetadata)
      .end((err, res) => {
        const apiError = err ? new ApiErrorModel(err) : null;
        callback(apiError, res.body.data);
      });
  },

  leaveGroup(profileId, groupId, callback) {
    if (callback) {
      return GroupApi.leave(profileId, groupId)
        .end((err) => {
          const apiError = err ? new ApiErrorModel(err) : null;
          callback(apiError, null);
        });
    } else {
      return GroupApi.leave(profileId, groupId).then(() => null);
    }

  },

  getShareCardGroupContents(profileId) {
    return GroupApi.getGroupContents(profileId, 'share_card');
  },
};

export default GroupService;
